import {
  DataWarehouseObjectType,
  DbtObjectType,
  DbtObjectTypes,
  DWHWarehouseObjectTypes,
  QueryPageWarehouse,
} from '@dbt-labs/integrations/productHandoffs/productHandoffURIs';

import { WarehouseEntityType } from '@/__generated__/graphql';

const insightsResourceTypes = [
  'model',
  'source',
  'snapshot',
  'seed',
  'metric',
  'saved_query',
] as const;

export type InsightsResourceType = (typeof insightsResourceTypes)[number];

export const isResourceSupported = (resourceType: InsightsResourceType): boolean => {
  return insightsResourceTypes.includes(resourceType);
};

export const resourceTypeToDbtObjectType: Record<InsightsResourceType, DbtObjectType> =
  {
    model: DbtObjectTypes.MODEL,
    source: DbtObjectTypes.SOURCE,
    snapshot: DbtObjectTypes.SNAPSHOT,
    seed: DbtObjectTypes.SEED,
    metric: DbtObjectTypes.METRIC,
    saved_query: DbtObjectTypes.SEMANTIC_LAYER_SAVED_QUERY,
  };

const insightsAssetTypes = [
  WarehouseEntityType.Table,
  WarehouseEntityType.View,
] as const;

export type InsightsAssetType = (typeof insightsAssetTypes)[number];

export const isAssetSupported = (assetType: InsightsAssetType): boolean => {
  return insightsAssetTypes.includes(assetType);
};

export const entityTypeToDataWarehouseObjectType: Record<
  InsightsAssetType,
  DataWarehouseObjectType
> = {
  [WarehouseEntityType.Table]: DWHWarehouseObjectTypes.TABLE,
  [WarehouseEntityType.View]: DWHWarehouseObjectTypes.VIEW,
};

export type InsightsDataWarehouseObject = {
  type: InsightsAssetType;
  id: string;
  qualifiedName: string;
  warehouseType: QueryPageWarehouse;
};
